"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NavMenu = _interopRequireDefault(require("./NavMenu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const NavMenuControlled = (_ref) => {
  let _ref$menu = _ref.menu,
      menu = _ref$menu === void 0 ? [] : _ref$menu,
      _ref$menuByUrl = _ref.menuByUrl,
      menuByUrl = _ref$menuByUrl === void 0 ? {} : _ref$menuByUrl,
      currentUrl = _ref.currentUrl,
      onSelect = _ref.onSelect,
      onToggle = _ref.onToggle,
      props = _objectWithoutPropertiesLoose(_ref, ["menu", "menuByUrl", "currentUrl", "onSelect", "onToggle"]);

  const _useState = (0, _react.useState)({}),
        selectedByUrl = _useState[0],
        setSelectedByUrl = _useState[1];

  const handleSelect = (item, event) => {
    const url = item.url;
    url && !currentUrl && setSelectedByUrl({
      [url]: {
        selected: true
      }
    });
    onSelect && onSelect(item, event);
  };

  const _useState2 = (0, _react.useState)({}),
        expandedByUrl = _useState2[0],
        setExpandedByUrl = _useState2[1];

  const handleToggle = (item, event) => {
    const url = item.url,
          expanded = item.expanded;
    url && setExpandedByUrl(_extends({}, expandedByUrl, {
      [url]: {
        expanded: !expanded
      }
    }));
    onToggle && onToggle(item, event);
  };

  return _react.default.createElement(_NavMenu.default, _extends({
    menu: menu,
    menuByUrl: menuByUrl,
    currentUrl: currentUrl,
    expandedByUrl: expandedByUrl,
    onToggle: handleToggle,
    selectedByUrl: selectedByUrl,
    onSelect: handleSelect
  }, props));
};

var _default = NavMenuControlled;
exports.default = _default;
module.exports = exports.default;